/**
 * "just now" / "12 min ago" / "3h ago" / "2d ago", falling back to an absolute
 * date once a week has passed — past that, "9d ago" is harder to place than
 * the date itself.
 *
 * Shared by the document-info popover and the properties panel, which both
 * render a document's `updatedAt`.
 */
export function formatRelativeDate(iso: string): string {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Intl.DateTimeFormat(navigator.language, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(iso));
}
